import { Box, Typography, styled } from "@mui/material";
import { themePalette } from "../../../theme";

export const HEADER_HEIGHT = "63px";
export const CLINIC_CONTEXT_HEADER_HEIGHT = "82px";
export const LOGO_WIDTH = "auto";

export const HeaderContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "hasSubtitle",
})<{ hasSubtitle: boolean }>(({ hasSubtitle }) => ({
  width: "100%",
  height: hasSubtitle ? CLINIC_CONTEXT_HEADER_HEIGHT : HEADER_HEIGHT,
  background: themePalette.headerBackground,
  padding: "8px 24px",
  display: "flex",
  alignItems: "center",
  boxSizing: "border-box",
}));

export const HeaderLogo = styled("img")({
  width: LOGO_WIDTH,
  maxWidth: "100%",
  height: "30px",
  display: "block",
});

export const HeaderContent = styled(Box)({
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "4px",
});

export const HeaderSubtitle = styled(Typography)({
  color: "white",
  fontSize: "11px",
  lineHeight: "14px",
  maxWidth: "100%",
  textAlign: "left",
  overflowWrap: "anywhere",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 2,
  overflow: "hidden",
});
